

import XHeader from 'vux/src/components/x-header/index.vue'
import Alert from 'vux/src/components/alert/index.vue'


export default {
components: {
XHeader,
Alert
},
data () {
return {
initPassword:'',
newPassWord:'',
show: false,
message:'',
model:{mobile:"",initPassword:"",password:""}
}
},
created(){
this.getCheckCode();
},
mounted(){
this.footjs();
},
methods: {
footjs(){
let hm = document.createElement("script");
hm.src = "https://hm.baidu.com/hm.js?22c1001a656acb63c91abffeeb5e9419";
let s = document.getElementsByTagName("script")[0];
s.parentNode.insertBefore(hm, s);
},
goBack(){
this.$router.go(-1)
},
go(){
this.$router.push("/auth/login")
},
getCheckCode(){
var mobile = this.$route.query.mobile;
if(mobile == undefined || mobile == null || mobile == ""){
this.$router.push("/auth/fotgetPassword")
}
var self=this
this.$http.post(this.global.httpUrl + '/rest/v1/m/safe/forgetPassword/checkCode2',{mobile:mobile},{emulateJSON:true}).then(function(res){
if(res.body.success){
self.model.mobile=res.body.mobile;
}else{
self.$vux.alert.show({
title:"消息",
content:res.body.message,
onShow(){
self.$router.push({path : '/auth/fotgetPassword',query : {}});
}
});

}
},function(res){
console.log(res.status);
});
},
updatePassWord(){
if(this.initPassword == null || this.initPassword ==''){
this.show=true;
this.message="请输入新密码";
return;
}
if(this.newPassWord == null || this.newPassWord =='' ){
this.show=true;
this.message="请输入确认密码";
return;
}
if(this.initPassword.trim() != this.newPassWord.trim()){
this.show=true;
this.message="两次密码输入不一致";
return;
}

if(this.model.mobile == null || this.model.mobile ==''){
this.show=true;
this.message="非法操作";
return;
}
var self=this


let rasPw = this.$getRsaCode(self.newPassWord);

this.$http.post(this.global.httpUrl + '/rest/v1/m/safe/forgetPassword/updatePassWord',{mobile:self.model.mobile,passWord:rasPw},{emulateJSON:true}).then(function(res){
if(res.body.success){
this.$vux.alert.show({
title:"消息",
content:"修改成功！",
onShow(){
self.$router.push({path : '/auth/login',query : {}});
}
});

}else {
this.show=true;
this.message=res.body.msg;
}
},function(res){
console.log(res.status);
});

}
}
}



// WEBPACK FOOTER //
// ./src/views/auth/fotgetPassword2.vue